import { useEffect } from 'react'
import SearchIcon from '@/assets/icons/icon-search.svg?react'
import SidebarUiButton from '../SidebarUiButton/SidebarUiButton'
import Tooltip from '@/components/ui/Tooltip/Tooltip'
import { useAppDispatch } from '@/store/hooks'
import { setOpenModal, setMobileSidebarOpen } from '@/store/ui/uiSlice'

const SidebarSearchButton = () => {
    const dispatch = useAppDispatch()

    const openSearch = () => {
        // Close the mobile drawer so the search palette isn't covered by it (no-op on desktop).
        dispatch(setMobileSidebarOpen(false))
        dispatch(setOpenModal({ type: 'search' }))
    }

    // ⌘K / Ctrl+K opens search from anywhere in the authed app.
    useEffect(() => {
        const onKeyDown = (e: KeyboardEvent) => {
            if ((e.metaKey || e.ctrlKey) && (e.key === 'k' || e.key === 'K')) {
                e.preventDefault()
                dispatch(setOpenModal({ type: 'search' }))
            }
        }
        document.addEventListener('keydown', onKeyDown)
        return () => document.removeEventListener('keydown', onKeyDown)
    }, [dispatch])

    return (
        <Tooltip title="Search">
            <SidebarUiButton icon={<SearchIcon />} title="Search" onClick={openSearch} />
        </Tooltip>
    )
}

export default SidebarSearchButton
